import {
  EventInfoAction,
  EventInfoCategory,
  trackTradidionalGaEvent,
} from '@/components/GoogleTagManager';

export const addGtmTrackingToEpiserverForms = (
  element: Element,
  gtmTrackingTitle: string,
) => {
  // check if form exist and add GA tracking event on submit button if there is one
  const form = element.querySelector('.EPiServerForms');
  if (form) {
    // add event listener to submit button and send GTM event
    const submitButton = form.querySelector('button[type=submit]');
    if (submitButton) {
      submitButton.addEventListener('click', function () {
        trackTradidionalGaEvent(
          EventInfoCategory.Newsletter,
          EventInfoAction.Button,
          gtmTrackingTitle,
        );
      });
    }
  }
};
